import classNames from 'classnames';
import { Button, Form } from 'react-bootstrap';
import type { ChangeEventHandler } from 'react';

type RadioItemProps = {
  name: string;
  label: string;
  active?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  image: string;
};

const RadioItem = ({
  name,
  label,
  active = false,
  onChange,
  image
}: RadioItemProps) => {
  return (
    <Button
      variant="theme-default"
      className={classNames({ active: active }, 'border-0')}
    >
      <Form.Label
        htmlFor={`${name}-${label}`}
        className="cursor-pointer hover-overlay"
      >
        <img className="w-100" src={image} alt="" />
      </Form.Label>
      <Form.Check
        type="radio"
        id={`${name}-${label}`}
        label={label.charAt(0).toUpperCase() + label.slice(1)}
        name={name}
        onChange={onChange}
        checked={active}
      />
    </Button>
  );
};

export default RadioItem;
